import { createSlice } from '@reduxjs/toolkit';

// Helper function to decode JWT token and extract expiry
const decodeToken = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

const initialState = {
  refreshToken: null,
  accessTokenExpiry: null, // Track access token expiry instead
};

const refreshTokenSlice = createSlice({
  name: 'refreshToken',
  initialState,
  reducers: {
    restoreRefreshToken: (state) => {
      // Restore from localStorage on app init
      const storedRefreshToken = localStorage.getItem('care_refresh_token');
      const storedAccessTokenExpiry = localStorage.getItem('care_access_token_expiry');
      
      if (storedRefreshToken) {
        state.refreshToken = storedRefreshToken;
      }
      
      if (storedAccessTokenExpiry) {
        state.accessTokenExpiry = parseInt(storedAccessTokenExpiry);
      }
    },
    setRefreshToken: (state, action) => {
      const { refreshToken } = action.payload;
      state.refreshToken = refreshToken;
      
      // Persist refresh token to localStorage
      if (refreshToken) {
        localStorage.setItem('care_refresh_token', refreshToken);
        //console.log('[Redux] Refresh token stored');
      }
    },
    setAccessTokenExpiry: (state, action) => {
      const { accessToken } = action.payload;
      
      // Decode access token to extract expiry
      if (accessToken) {
        const decodedToken = decodeToken(accessToken);
        if (decodedToken && decodedToken.exp) {
          state.accessTokenExpiry = decodedToken.exp;
          
          // Persist access token expiry to localStorage
          localStorage.setItem('care_access_token_expiry', decodedToken.exp.toString());
        }
      }
    },
    clearRefreshToken: (state) => {
      state.refreshToken = null;
      state.accessTokenExpiry = null;
      
      // Clear from localStorage
      localStorage.removeItem('care_refresh_token');
      localStorage.removeItem('care_access_token_expiry');
    },
  },
});

export const { restoreRefreshToken, setRefreshToken, setAccessTokenExpiry, clearRefreshToken } = refreshTokenSlice.actions;
export default refreshTokenSlice.reducer;